import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { CREATIVE_ASSET_TYPES, CREATIVE_NAMES, INSERTION_MODES, VIDEO_PARALLAX_AD_FIELDS } from "./definitions";
import InputTextSection from "./InputTextSection";
import DropdownSection from "./DropdownSection";
import VideoAssetCreativeType from "./VideoAssetCreativeType";
import BaseCreativeControls from "./BaseCreativeControls";
import { InputSwitch } from "primereact/inputswitch";

const CREATIVE_TYPE = CREATIVE_NAMES.VIDEO_PARALLAX;

const switchSectionStyles = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1em;
    .label {
        flex-basis: 80%;
    }
`

export default function ParallaxVideo({
    videoCreativeURL,
    container,
    handleChange,
    currentCustomer,
    impressionTag,
    clickTag,
    vastUrl,
    vastDuration,
    topOffset,
    bottomOffset,
    insertionMode,
    videoCreativeType,
    adServingType,
    showLabels,
    zindex,
    delayExec,
    mobileTopOffset
}) {
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
            >
                <div css={switchSectionStyles}>
                    <span className="label">
                        <p><b>Render when DOM ready</b></p>
                    </span>
                    <InputSwitch
                        checked={!!delayExec}
                        name={VIDEO_PARALLAX_AD_FIELDS.delayExec}
                        onChange={e => {
                            handleChange(e, e.value, CREATIVE_TYPE)
                        }}
                    />
                </div>
                <div css={switchSectionStyles}>
                    <span className="label">
                        <p><b>Show advertisement labels (mobile only)</b></p>
                    </span>
                    <InputSwitch
                        checked={showLabels}
                        name={VIDEO_PARALLAX_AD_FIELDS.showLabels}
                        onChange={e => {
                            handleChange(e, e.value, CREATIVE_TYPE)
                        }}
                    />
                </div>
                <VideoAssetCreativeType
                    dropdownLabel="Video Creative Type"
                    types={CREATIVE_ASSET_TYPES}
                    videoCreativeTypePropertyName={VIDEO_PARALLAX_AD_FIELDS.videoCreativeType}
                    videoCreativeType={videoCreativeType || 'video'}
                    handleChange={handleChange}
                    CREATIVE_TYPE={CREATIVE_TYPE}
                    currentCustomer={currentCustomer}
                    videoUrlInputLabel="Video URL"
                    videoUrlInputName={VIDEO_PARALLAX_AD_FIELDS.videoCreativeURL}
                    videoUrl={videoCreativeURL}
                    vastInputName={VIDEO_PARALLAX_AD_FIELDS.vastUrl}
                    vastUrl={vastUrl}
                    vastDurationInputName={VIDEO_PARALLAX_AD_FIELDS.vastDuration}
                    vastDuration={vastDuration}
                />
                <InputTextSection
                    label={"Container CSS selector"}
                    name={VIDEO_PARALLAX_AD_FIELDS.container}
                    value={container}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={true}
                    uriEncodeValue={false}
                />
                <InputTextSection
                    label={"Top offset (px)"}
                    name={VIDEO_PARALLAX_AD_FIELDS.topOffset}
                    value={topOffset}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    uriEncodeValue={false}
                    isNumericInput={true}
                />
                <InputTextSection
                    label={"Mobile top offset (px)"}
                    name={VIDEO_PARALLAX_AD_FIELDS.mobileTopOffset}
                    value={mobileTopOffset}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    uriEncodeValue={false}
                    isNumericInput={true}
                />
                <InputTextSection
                    label={"Bottom offset (px)"}
                    name={VIDEO_PARALLAX_AD_FIELDS.bottomOffset}
                    value={bottomOffset}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    uriEncodeValue={false}
                    isNumericInput={true}
                />
                <InputTextSection
                    label="zindex (integer)"
                    name={VIDEO_PARALLAX_AD_FIELDS.zindex}
                    value={zindex}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    isNumericInput={true}
                />
                <DropdownSection
                    label="DOM insertion mode"
                    name={VIDEO_PARALLAX_AD_FIELDS.insertionMode}
                    optionLabel="label"
                    optionValue="value"
                    options={INSERTION_MODES}
                    value={insertionMode}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                />
            </BaseCreativeControls>
        </>
    );
}
